/**
 * Pedir el enlace para restablecer una clave olvidada (ADM-01).
 *
 * Igual que el acceso, no dice nunca si el correo tiene cuenta: tras enviar,
 * el mensaje es el mismo para todos. Si lo dijera, esta pantalla serviria para
 * averiguar quienes son los administradores.
 */
import { useState } from 'react';
import type { FormEvent } from 'react';
import { Link } from 'react-router-dom';

import { Icono } from '../../componentes/comunes/Icono';
import { Seo } from '../../seo/Seo';
import { recuperarClave } from '../../servicios/autenticacion.servicio';
import { ErrorDeApi } from '../../servicios/cliente-api';
import { rutas } from '../../utilidades/rutas';

export function RecuperarClave() {
  const [email, setEmail] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  async function enviar(evento: FormEvent<HTMLFormElement>): Promise<void> {
    evento.preventDefault();
    setError(null);
    setEnviando(true);

    try {
      await recuperarClave({ email });
      setEnviado(true);
    } catch (fallo) {
      setError(
        fallo instanceof ErrorDeApi
          ? (fallo.detalles?.[0]?.mensaje ?? fallo.message)
          : 'No pudimos conectarnos con el servidor. Intenta de nuevo.',
      );
    } finally {
      setEnviando(false);
    }
  }

  return (
    <>
      <Seo
        titulo="Recuperar la clave"
        descripcion="Recuperación de la clave del panel de administración."
        ruta={rutas.administracion.recuperarClave()}
        sinIndexar
      />

      <main className="acceso">
        <div className="acceso-caja">
          <div className="acceso-marca">
            <span className="acceso-icono">
              <Icono nombre="llave" />
            </span>
          </div>

          <h1>Recuperar la clave</h1>

          {enviado ? (
            <>
              <p className="acceso-bajada">
                Si <strong>{email.trim()}</strong> tiene una cuenta activa, en unos minutos le llega
                un correo con un enlace para elegir una clave nueva. El enlace vale por una hora.
              </p>
              <p className="acceso-nota">
                ¿No llegó? Revisa la carpeta de spam, o pídele a otro administrador que revise
                tu cuenta.
              </p>
            </>
          ) : (
            <>
              <p className="acceso-bajada">
                Escribe el correo de tu cuenta y te mandamos un enlace para elegir una clave nueva.
              </p>

              <form
                onSubmit={(evento) => {
                  void enviar(evento);
                }}
                noValidate
              >
                {error !== null ? (
                  <p className="acceso-error" role="alert">
                    <Icono nombre="alerta" />
                    <span>{error}</span>
                  </p>
                ) : null}

                <div className="campo">
                  <label htmlFor="recuperar-email">Correo</label>
                  <input
                    id="recuperar-email"
                    name="email"
                    type="email"
                    autoComplete="username"
                    required
                    value={email}
                    onChange={(evento) => {
                      setEmail(evento.target.value);
                    }}
                  />
                </div>

                <button
                  type="submit"
                  className="btn btn-primario btn-lg btn-bloque"
                  disabled={enviando}
                >
                  {enviando ? 'Enviando…' : 'Enviar el enlace'}
                </button>
              </form>
            </>
          )}

          <p className="acceso-enlace">
            <Link to={rutas.administracion.acceso()}>Volver a entrar</Link>
          </p>
        </div>
      </main>
    </>
  );
}
